module.exports = __webpack_public_path__ + "static/media/persona-halil.c5cfe0e4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/persona-halil.svg
// module id = 47
// module chunks = 0